import { onlineExamManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher];

const onlineExamManagementRouteMetadata: IRouteMetadataObj<
  typeof onlineExamManagementRoutesObj
> = {
  list: {
    title: "onlineExamManagement.index.title",
    description: "onlineExamManagement.index.description",
    lazy: () => import("@/pages/onlineExamManagement/table/page"),
    mode: "index",
    type: "main",
    icon: "FileEditLine",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "onlineExamManagement.create.title",
    description: "onlineExamManagement.create.description",
    lazy: () => import("@/pages/onlineExamManagement/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "onlineExamManagement.edit.title",
    description: "onlineExamManagement.edit.description",
    lazy: () => import("@/pages/onlineExamManagement/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "onlineExamManagement.view.title",
    description: "onlineExamManagement.view.description",
    lazy: () => import("@/pages/onlineExamManagement/view/page"),
    mode: "edit",
    type: "inner",
    icon: "GraduationCapLine",
    breadcrumbs: [],
    permission,
  },
};

export const onlineExamManagementRoutes = createRoute<
  typeof onlineExamManagementRoutesObj
>(onlineExamManagementRoutesObj, onlineExamManagementRouteMetadata);
